/**
 * Footer
 * @module components/Footer
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import style from './Footer.scss';
import RteContent from 'components/RteContent';
import { Grid, Row, Col } from 'components/Grid';
import Layout from 'components/Layout';

/** Class representing the component. */
class Footer extends Component {

	/**
	 * Renders each footer section
	 */
	renderSections () {
		const { sections } = this.props;

		return sections.map((section, i) => {
			return (
				<Col xs={12} md={3} key={i}>
					<section className={section.title ? '' : style.noTitle}>
						{ section.title && <h2>{section.title}</h2> }
						<RteContent content={section.content} type="small" color="white" />
					</section>
				</Col>
			);
		});
	}


	/**
	 * The render method
	 */
	render () {
		const { copyright } = this.props;

		return (
			<footer className={style.footer}>
				<Layout color="black">
					<div className={style.content}>
						<Grid>
							<Row>
								<img src="/static/industriALL-logo-white.svg" className={style.logo} alt="IndustriALL logo" aria-hidden="true" />
								{this.renderSections()}
							</Row>
						</Grid>
					</div>
				</Layout>

				{ copyright && (
					<section className={`${style.outerWrapper} ${style.grey}`}>
						<div className={style.bottomBar}>
								<RteContent content={copyright} type="small" color="white" />
						</div>
					</section>
				)}
			</footer>
		)
	}
}


/** Prop types **/
Footer.propTypes = {
	sections: PropTypes.array,
	copyright: PropTypes.string
};


export default Footer;
